/**
 * 锚点demo
 * @description 锚点demo
 * @author mll
 * @date 2020-2-13
 */
import React from 'react';
import { connect } from 'dva';

import { component_tool, framework_tool } from '../../../tool'
let { WizAnchor } = component_tool;
let { WizContainer } = framework_tool;
let { Link } = WizAnchor
class Anchor extends WizContainer {

    componentName = 'Anchor';

    scrollToAnchor = (anchorName) => {
        if (anchorName) {
            let anchorElement = document.getElementById(anchorName);
            if (anchorElement) { anchorElement.scrollIntoView(); }
        }
    }

    _render() {

        return (
            <div>
                <div>
                    <a onClick={() => this.scrollToAnchor('pink')}>
                        <button>
                            跳转粉色背景区域
                        </button>
                    </a>
                    <a onClick={() => this.scrollToAnchor('skyblue')}>
                        <button>
                            跳转蓝色背景区域
                        </button>
                    </a>
                    <a onClick={() => this.scrollToAnchor('green')}>
                        <button>
                            跳转绿色背景区域
                        </button>
                    </a>
                </div>
                <div id="skyblue" style={{ height: 1000, backgroundColor: 'skyblue', margin: 50 }} />
                <div id="pink" style={{ height: 1000, backgroundColor: 'pink', margin: 50 }} />
                <div id="green" style={{ height: 1000, backgroundColor: 'green', margin: 50 }} />
            </div>
        );
    }

}

const mapStateToProps = (state, ownProps) => {
    return {

    };
};

export default connect(mapStateToProps)(Anchor);
